export default __webpack_public_path__ + "static/media/license_owner_icon.c51708dd.svg";